import React, { forwardRef } from 'react';
import { Input } from 'antd';

const NumberInput = forwardRef(({ onChange, ...props }, ref) => {
  const handleChange = (e) => {
    const value = e.target.value;
    const reg = /^([0-9]*)$/;

    const isValid = !isNaN(value) && reg.test(value);
    const hasOnChange = typeof onChange === 'function';

    if (hasOnChange && isValid) {
      onChange(value);
    }
  };

  return <Input ref={ref} {...props} onChange={handleChange} />;
});

export default NumberInput;
